import getRemoteKey from "../services/remoteService";
// FIXME Move this to the remote folder to have everything together
export default keyCodeList => {
  function init() {
    removeEvent();
    addEvent();
  }

  function addEvent() {
    document.body.addEventListener("keydown", keyCodeHandler);
  }

  function removeEvent() {
    document.body.removeEventListener("keydown", keyCodeHandler);
  }

  function keyCodeHandler(event) {
    const pressedKey = getRemoteKey(event.keyCode, event.ctrlKey, event.altKey);
    const keyListener = keyCodeList[pressedKey];
    if (typeof keyListener === "function") {
      keyListener();
    }
  }
  init();
};
